var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-tooltip table"},[_c('button',{staticClass:"price-tooltip-close",on:{"click":function($event){return _vm.closeTolltip()}}},[_c('svg',{staticClass:"close"},[_c('use',{attrs:{"xlink:href":"#close"}})])]),_vm._v(" "),_c('p',{staticClass:"info"},[_vm._v("Verified spots have our team’s stamp of approval.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }